"use client";

import {
  formatMenuFreshnessLabel,
  freshnessBadgeClassName,
  getMenuFreshness,
  MENU_BADGE_BASE_CLASS,
  type MenuFreshnessInput,
} from "@/lib/menus/menuFreshness";
import { useLanguage } from "@/lib/useLanguage";

type Props = MenuFreshnessInput & {
  className?: string;
};

export function MenuFreshnessBadge({ className = "", ...input }: Props) {
  const { language, t } = useLanguage();
  const freshness = getMenuFreshness(input);
  if (!freshness) return null;

  const strings = t.menuFreshness;
  const label = formatMenuFreshnessLabel(
    freshness.label,
    {
      uploadedToday: strings?.uploadedToday ?? "Subido hoy",
      uploadedYesterday: strings?.uploadedYesterday ?? "Subido ayer",
      uploadedHoursAgo: strings?.uploadedHoursAgo ?? "Subido hace {hours} h",
      uploadedDaysAgo: strings?.uploadedDaysAgo ?? "Subido hace {count} días",
      uploadedOnDate: strings?.uploadedOnDate ?? "Subido el {date}",
    },
    language
  );

  return (
    <span
      className={`${MENU_BADGE_BASE_CLASS} ${freshnessBadgeClassName(freshness.severity)} ${className}`}
    >
      {label}
    </span>
  );
}
